import { render } from "./introductions.vue?vue&type=template&id=e0929076"
import script from "./introductions.vue?vue&type=script&lang=ts"
export * from "./introductions.vue?vue&type=script&lang=ts"
script.render = render

export default script